export default __webpack_public_path__ + "static/media/Happy.9348018f.svg";